import { render, staticRenderFns } from "./CreatePerformanceReportVersionPage.vue?vue&type=template&id=41d73606&scoped=true"
import script from "./CreatePerformanceReportVersionPage.vue?vue&type=script&lang=js"
export * from "./CreatePerformanceReportVersionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d73606",
  null
  
)

export default component.exports